<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" @click="close()">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">
						Componer
						<template v-if="attribute">
							{{ attribute.name }}
						</template>
					</h4>
				</div>
				<div v-if="attribute" class="modal-body">
					<div class="row">
						<div v-if="operations" class="col-md-6">
							<div v-if="operations.length" class="form-group">
								<label class="control-label">Operación</label>
								<select ref="composerOperator" v-model="operator" v-if="operations.length" class="form-control">
									<option v-for="operation in operations" :value="operation">{{ operation.name }}</option>
								</select>
							</div>
						</div>
					</div>

					<div class="row">
						<div v-if="attribute" class="col-md-12">
							<multiselect
								@input="operate"
								v-model="attribute.childs"
								label="name"
								:options="attributes"
								track-by="id"
								placeholder="Seleccionar valores"
								:multiple="true">
							</multiselect>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button @click="save()" ref="btnSave" type="button" class="btn btn-success">Guardar</button>
					<button type="button" class="btn btn-default" @click="close()">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'itemAttributes'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-attribute-composer-' + Math.floor(Math.random() * 736456),
				},

				operator: null,
				attribute: null,
				originalAttribute: null,
				attributes: null,
				operations: null,

				total: null,
			}
		},
		watch: {
			operator() {
				if(this.attribute) {
					this.attribute.product_operation_id = this.operator.id
					this.operate()
				}
			},
			operations() {
				if(this.operations.length) {
					if(!this.operator) {
						this.operator = this.operations[0]
						if(this.attribute) {
							this.attribute.product_operation_id = this.operator.id
						}
					}
				}
			},
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getOperations()
			},
			open(attribute) {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.originalAttribute = attribute
				this.attribute = JSON.parse(JSON.stringify(attribute))

				if(this.operations) {
					if(this.operations.length) {
						if(!this.operator) {
							this.operator = this.operations[0]
						}
						this.attribute.product_operation_id = this.operator.id
					}
				}
				this.filter()
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getOperations () {
				this.$http.get('admin/management/products/operation')
					.then(response => {
						this.operations = response.body
					})
			},
			filter() {
				var that = this
				var attributes = []

				this.itemAttributes.find(function(element, key) {
					if(element.id != that.attribute.id) {
						if(element.product_attribute_storage_id) {
							if(element.product_attribute_storage_id == that.attribute.id) {
								var attr = Object.assign({}, element)
								attributes.push(attr)
							}
						} else {
							var attr = Object.assign({}, element)
							attributes.push(attr)
						}
					}

				})
				this.attributes = attributes
			},
			operate() {
				if(this.attribute) {
					if(this.operator) {
						if(this.attribute.childs) {
							if(this.attribute.childs.length) {
								var that = this
								var operation = ''

								this.attribute.childs.forEach(function(attribute, key) {
									var value = null
									if(attribute.product_attribute_type_field_id == 1) {
										if(attribute.value) {
											value = attribute.value.decimal_value
										}
									}
									if(attribute.product_attribute_type_field_id == 2) {
										if(attribute.value) {
											value = attribute.value.integer_value
										}
									}

									if(value) {
										operation += value
										if(that.attribute.childs.length - 1 > key) {
											operation += that.operator.symbol
										}
									}
								})
								if(operation) {
									var total = eval(operation)
									if(this.attribute.product_attribute_type_field_id == 1) {
										this.attribute.value.decimal_value = Number(parseFloat(total).toFixed(2))
									}
									if(this.attribute.product_attribute_type_field_id == 2) {
										this.attribute.value.integer_value = Number(total)
									}
								}
							} else {
								if(this.attribute.product_attribute_type_field_id == 1) {
									this.attribute.value.decimal_value = 1
								}
								if(this.attribute.product_attribute_type_field_id == 2) {
									this.attribute.value.integer_value = 1
								}
							}
						}
					}
				}
			},
			save() {
				var loading = Ladda.create(this.$refs.btnSave)
				loading.start()
				this.$http.post('admin/management/products/storages/' + this.attribute.product_storage_id + '/update/attribute/' + this.attribute.id, this.attribute)
				.then(response => {
					var attributes = response.body.data
					this.$emit('attributesUpdated', attributes)
					this.close()
					loading.stop()
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/AttributeComposer.vue